import { getActivityTitleOnly } from "encamp-shared/src/activity/activityDisplayNames";

import { WorkflowActivityStepper } from "../../../../../components/WorkflowActivityStepper";
import { useReportDetails } from "../useReportDetails";

// Backward compatibility wrapper for the FulfillmentDetails page
export function ActivityStepper() {
  const { data } = useReportDetails();

  const activities = data?.tierIIReport.currentWorkflow?.activities ?? [];
  const currentActivityId = data?.tierIIReport.currentWorkflow?.currentActivityId;
  const championReportId = data?.tierIIReport.id;

  return (
    <WorkflowActivityStepper
      activities={activities}
      currentActivityId={currentActivityId}
      showTooltips={true}
      showChampionIcon={true}
      showSecondaryText={false}
      showEmptyState={false}
      activityTitleFunction={getActivityTitleOnly}
      championReportId={championReportId}
      maxHeight="500px"
      replace={true}
    />
  );
}
